// LivestreamDetailOnlineHeader.js
import { connect } from 'react-redux';

import LivestreamDetailOnlineHeader from '../component/LivestreamDetailOnlineHeader.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getFormattedLiveStreamViewers from '../selector/getFormattedLiveStreamViewers.js';

import toggleModal from '../action/toggleModal.js';

import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );

  const isExclusivePrivatePerforming =
    ExclusivePrivateStatus.PERFORMING === exclusivePrivateStatus;
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );

  return {
    needStreamTokenForExclusivePrivatePerforming:
      isExclusivePrivatePerforming && !hasStreamToken,
    viewers: getFormattedLiveStreamViewers(state, streamId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamDetailOnlineHeader);
